import { Spinner } from "../../../../themes/loveli-theme/src/js/components/spinner";

import { numberInput, emailInput, form, submitBtn, productId, submitForm } from "./functions";

(async () => {
	if (!numberInput || !emailInput || !form) return;

	emailInput.addEventListener(
		"input",
		() => {
			numberInput.required = false;
		},
		{ once: true }
	);

	form.addEventListener("submit", async (e) => {
		e.preventDefault();

		if (numberInput.value) return;

		await handleFormSubmission(restockEmail.value);
	});
})();

/**
 * Defines the steps to take after a user submits the form
 *
 * @param {string} email
 */
async function handleFormSubmission(email) {
	const formInner = form.querySelector(".form-inner");
	const spinner = new Spinner("white");

	submitBtn.disabled = true;
	submitBtn.innerHTML += `<span class="ms-2">${spinner.outerHTML}</span>`;

	const alertEl = document.createElement("div");
	alertEl.classList.add("alert", "fade");
	alertEl.role = "alert";
	form.append(alertEl);

	let message = "Er is iets mis gegaan";

	try {
		const response = await submitForm(email);

		const success = response.success || false;

		if (response.data) message = response.data;

		if (!success) throw new Error("An error occurred while submitting your data. Please contact a developer.");

		alertEl.innerHTML = message;
		alertEl.classList.add("alert-success");
	} catch (err) {
		console.error(err);
		alertEl.classList.add("alert-danger");
		alertEl.innerHTML = message;
	} finally {
		formInner.remove();
		alertEl.classList.add("show");
	}
}
